import { Col, Row } from "react-bootstrap"
import { DeviceGroupEdit } from "../../components/DeviceGroup/DeviceGroupEdit"
import { DeviceFirmwareLink } from "../../components/Firmware/DeviceFirmwareLink"
import { RoleProtect } from "../../components/Authorization/RoleProtect"
import { Permission } from "../../api"

export const DeviceGroupDetail = () => (
    <Row className="content-section">
        <Col>
            <h2>Device group</h2>
            <DeviceGroupEdit />
            <RoleProtect allowedPermissions={[Permission.SetAnyResourceFirmware]}>
                <hr />
                <DeviceFirmwareLink />
            </RoleProtect>
        </Col>
    </Row>
)
